import { FC } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";

import { MainRoutes } from "common/config";
import ErrorBoundary from "common/components/custom/error-boundary";
import { PageTitleManager } from "common/components/custom/page-title/PageTitle";
import Layout from "layouts/Layout";
import LogoutLayout from "layouts/logout-layout/LogoutLayout";

const App: FC = () => {
  const location = useLocation();

  const isLogoutLayout =
    location?.pathname == MainRoutes.LOGOUT ||
    location.pathname == MainRoutes.SESSION_TIMEOUT ||
    location.pathname == MainRoutes.UNAUTHORIZED;

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <PageTitleManager />
        {!isLogoutLayout ? <Layout /> : <LogoutLayout />}
        <ToastContainer />
      </ErrorBoundary>
    </HelmetProvider>
  );
};

export default App;
